import React, { useEffect } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { RouterNavigation } from '../Navigation';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MoreIcon from '@material-ui/icons/MoreVert';
import { useAuth } from '../../../contexts/Auth';
import { useLocalStorage } from '../../../contexts/LocalStorage';
import { useHistory, useLocation } from 'react-router-dom';
import { ModalNotificacao } from '../ModalNotificacao';
import { ModalMensagens } from '../ModalMensagens';
import { useRelatorios } from '../../../contexts/Relatorios';
import { useDeepCompareEffect, useEffectOnce } from 'react-use';
import { getNotification } from '../../api/serviceNotifications';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        grow: {
            flexGrow: 1,
        },
        title: {
            marginRight: theme.spacing(3),
        },
        screenName: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block',
            },
        },
        menuUser: {
            color: '#414141',
            marginLeft: theme.spacing(1),
        },
        sectionDesktop: {
            color: '#414141',
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
            },
        },
        sectionMobile: {
            color: '#414141',
            display: 'flex',
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
    }),
);

export function NavBar() {
    let location: any = useLocation();
    const { logout } = useAuth();
    const { getFromSessionStorage } = useLocalStorage();
    const { notificacoes, setNotificacoes } = useRelatorios();
    const history = useHistory();
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<null | HTMLElement>(null);
    const [showModalNotifi, setShowModalNotifi] = React.useState<boolean>(false);
    const [showModalMensagens, setShowModalMensagens] = React.useState<boolean>(false);
    const [mensagens, setMensagens] = React.useState<string[]>([]);
    const [qtdNotificacoesPendentes, setQtdNotificacoesPendentes] =  React.useState<number>(0);

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = (param: string) => {
        setAnchorEl(null);
        handleMobileMenuClose();
        switch (param) {
            case "sair":
                logout(history);
                break;
            default:
                break;
        }
    };

    const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    function redirectTo(path: string) {
        history.push(process.env.PUBLIC_URL + path);
    }

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <div className={classes.menuUser}>
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
                id={menuId}
                keepMounted
                transformOrigin={{ vertical: 'center', horizontal: 'center' }}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={() => redirectTo("/usuario/perfil")}>Perfil</MenuItem>
                {/*<MenuItem onClick={() => handleMenuClose("")}>Configurações</MenuItem>*/}
                <MenuItem onClick={() => handleMenuClose("sair")}>Sair</MenuItem>
            </Menu>
        </div>
    );

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            <MenuItem onClick={() => setShowModalMensagens(!showModalMensagens)}>
                <IconButton aria-label="show new mails" color="inherit" >
                    <Badge badgeContent={0} color="secondary">
                        <MailIcon />
                    </Badge>
                </IconButton>
                Mensagens
            </MenuItem>
            <MenuItem onClick={() => setShowModalNotifi(!showModalNotifi)}>
                <IconButton aria-label="show new notifications" color="inherit">
                    <Badge badgeContent={qtdNotificacoesPendentes} color="secondary">
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
                Notificações
            </MenuItem>
            <MenuItem onClick={handleProfileMenuOpen}>
                <IconButton
                    aria-label="Conta do usuário"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                >
                    <AccountCircle />
                </IconButton>
                Usuário
            </MenuItem>
        </Menu>
    );

    useEffectOnce(() => {
        async function execute() {
            getNotification("", getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(result => {
                    setNotificacoes(result instanceof Array ? result : [result]);
                })
                .catch(error => {
                    console.log(error)
                })
        }
        if (location.state !== undefined && location.state.from !== undefined && location.state.from === "/login") {
            execute();
        }
    })

    
    useEffect(() => {
        let qtd : number = 0;
        for (let index = 0; index < notificacoes.length; index++) {
            const element = notificacoes[index];
            if(element.visualizado === 0){
                qtd = qtd + 1;
            }
        }
        setQtdNotificacoesPendentes(qtd);
    },[notificacoes]);

    return (
        <div className="navbar-container">
            <RouterNavigation />
            <div className={classes.grow} />
            <div className={classes.sectionDesktop}>
                <IconButton aria-label="show new mails" color="inherit" onClick={() => setShowModalMensagens(!showModalMensagens)}>
                    <Badge badgeContent={0} color="error">
                        <MailIcon />
                    </Badge>
                </IconButton>
                <IconButton aria-label="show new notifications" color="inherit" onClick={() => setShowModalNotifi(!showModalNotifi)}>
                    <Badge badgeContent={qtdNotificacoesPendentes} color="error">
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
                <div style={{ width: '1em' }}></div>
                <IconButton
                    edge="start"
                    aria-label="Conta do usuário"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                    style={{ borderRadius: '10px' }}
                >
                    <AccountCircle />
                    <Typography className={classes.menuUser} variant="h6" noWrap>
                        {getFromSessionStorage("user_name")}
                    </Typography>
                </IconButton>
            </div>
            <div className={classes.sectionMobile}>
                <IconButton
                    aria-label="show more"
                    aria-controls={mobileMenuId}
                    aria-haspopup="true"
                    onClick={handleMobileMenuOpen}
                    color="inherit"
                >
                    <MoreIcon />
                    <Typography className={classes.menuUser} variant="h6" noWrap>
                        {getFromSessionStorage("user_name")}
                    </Typography>
                </IconButton>
            </div>
            {renderMobileMenu}
            {renderMenu}
            <ModalNotificacao showModal={showModalNotifi} setShowModal={setShowModalNotifi} notificacoes={notificacoes}/>
            <ModalMensagens showModal={showModalMensagens} setShowModal={setShowModalMensagens}/>
        </div>
    );
}